import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "label", "value", "onChange", "error", "id", "placeholder", "clearable", "slotProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { DateTimePicker, dateTimePickerToolbarClasses } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { pickersToolbarTextClasses } from '@mui/x-date-pickers/internals';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import theme from '../../../../theme/theme';
dayjs.extend(utc);
var baseActions = ['clear', 'cancel', 'accept'];
export var FormDateTimePicker = function (props) {
    var _a, _b;
    var _slotProps$toolbar;
    var _c = props.name, name = _c === void 0 ? 'DateTime' : _c, label = props.label, value = props.value, onChange = props.onChange, error = props.error, id = props.id, placeholder = props.placeholder, _d = props.clearable, clearable = _d === void 0 ? true : _d, _e = props.slotProps, slotProps = _e === void 0 ? {} : _e, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(LocalizationProvider, {
        dateAdapter: AdapterDayjs
    }, /*#__PURE__*/ React.createElement(DateTimePicker, _extends({
        name: name,
        value: value && dayjs(value),
        onAccept: function (time) {
            var _dayjs$utc;
            return onChange === null || onChange === void 0 ? void 0 : onChange(null, time && ((_dayjs$utc = dayjs.utc(time)) === null || _dayjs$utc === void 0 ? void 0 : _dayjs$utc.format()));
        },
        formatDensity: "spacious",
        timezone: "system",
        desktopModeMediaQuery: theme.breakpoints.up('sm'),
        slotProps: {
            textField: _objectSpread({
                id: id,
                size: "small",
                sx: {
                    mx: 0
                },
                fullWidth: true,
                error: !!error,
                helperText: error,
                placeholder: placeholder
            }, slotProps.textField),
            field: _objectSpread({
                clearable: true,
                onClear: function (e) { return onChange && onChange(e, null, 'clear'); }
            }, slotProps.field),
            openPickerButton: _objectSpread({
                id: name + '-open-picker-btn'
            }, slotProps.openPickerButton),
            actionBar: {
                actions: clearable ? baseActions : baseActions.filter(function (action) { return action !== 'clear'; }),
                disableSpacing: true
            },
            toolbar: _objectSpread(_objectSpread({}, slotProps.toolbar), {}, {
                sx: _objectSpread((_a = {},
                    _a["& .".concat(dateTimePickerToolbarClasses.timeDigitsContainer)] = (_b = {},
                        _b["& .".concat(pickersToolbarTextClasses.root)] = {
                            fontSize: 'xxl'
                        },
                        _b.alignItems = 'center',
                        _b),
                    _a), (_slotProps$toolbar = slotProps.toolbar) === null || _slotProps$toolbar === void 0 ? void 0 : _slotProps$toolbar.sx)
            })
        }
    }, others)));
};
